// @flow

import { parse as astParse } from 'acorn'
import { Environment } from './sandbox'

export type RunCodeOpts = { isDebug?: boolean };

export function getJsEnv (scopes: Array<?Object>) {
  const sandboxEnv = new Environment(scopes)

  return {
    runCode (code: string, opts?: Object = {}) {
      try {
        const ast = astParse(code)
        if (opts.isDebug) {
          console.log(ast)
        }
        return sandboxEnv.gen(ast)()
      } catch (e) {
        if (opts.isDebug) {
          console.log(e)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/frame/jsEnv/jsEnv.js